/*
包含一些常量值的模块
 */
export const PAGE_SIZE = 15 // 每页显示的记录数
// export const BASE_IMG_URL = 'http://localhost:5000/upload/' // 上传图片的基础路径
// export const BASE_DOMIN = 'http://app.me:8082/api';
export const BASE_DOMIN = 'https://jkfan.cn/api';
